export const testimonials = [
  // PSYCHOLOGY (4)
  {
    name: "Aarav Mehta",
    initials: "AM",
    tag: "Psychotherapy · CBT",
    quote:
      "Six months ago I could not sleep through a single night. Dr. Kalpana didn't just hand me techniques — she helped me see the pattern beneath my anxiety. The CBT work she guided me through has been quietly life-changing.",
  },
  {
    name: "Priya Sharma",
    initials: "PS",
    tag: "Couples Therapy",
    quote:
      "We came in barely talking. Within weeks she had taught us how to listen — actually listen — without armour. Our marriage didn't only survive, it deepened. I think of her as the architect of our second beginning.",
  },
  {
    name: "Rohan Iyer",
    initials: "RI",
    tag: "Trauma Recovery",
    quote:
      "She held space for the parts of my story I had buried for fifteen years. Her steadiness makes the work possible. I walked into her practice broken; I walk through my life now whole.",
  },
  {
    name: "Sneha Kapoor",
    initials: "SK",
    tag: "Anxiety & Depression",
    quote:
      "What I love about Dr. Kalpana's approach is the lack of pretence. She is gentle, never patronising, and absurdly intuitive. The depression that had stolen years of my life began lifting after our third session.",
  },
  // PRANIC HEALING (4)
  {
    name: "Vikram Joshi",
    initials: "VJ",
    tag: "Pranic Healing · Pain Relief",
    quote:
      "Chronic lower-back pain for nine years. Two pranic sessions and the energetic congestion she described seemed to dissolve. I am back on the badminton court at 52. I cannot fully explain it, but I do not need to.",
  },
  {
    name: "Meera Nair",
    initials: "MN",
    tag: "Chakra Balancing",
    quote:
      "I came searching for clarity. I left with a quiet inside me I didn't know was possible. Dr. Kalpana works with such reverence — energy work in her hands feels like prayer with science underneath.",
  },
  {
    name: "Arjun Singh",
    initials: "AS",
    tag: "Emotional Trauma Clearing",
    quote:
      "The grief of losing my mother had compressed into my chest like a stone. After three sessions, the stone was simply gone. My breath came back. I sleep again. I will be grateful for the rest of my life.",
  },
  {
    name: "Lakshmi Reddy",
    initials: "LR",
    tag: "Spiritual Growth",
    quote:
      "I have worked with healers across three continents. None bring what Dr. Kalpana brings — clinical precision married to absolute soul-presence. She is rare, and Jaipur is lucky.",
  },
];
